import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import DataGridTamplet from "../Helper/TableTemplet/DataGridTamplet";
import { GridColDef } from "@mui/x-data-grid";
import MonthlyFeesUtils from "./MonthlyFeesUtils";
import { useParams } from "react-router-dom";
import userRoles from "../../configs/userRolesConfigs";


const MonthlyFees = () => {
    const dispatch = useDispatch();
    const defaultAccount = useSelector(
        (state: any) => state.account.default_account
    );
    const [items, setItems] = useState([]);
    const [totalCommissions, setTotalCommissions] = useState(0);
    const [userId, setUserId] = useState('');
    const userRole = useSelector((state: any) => state.general.userRol);
    const salespersons = useSelector((state: any) => state.user.salesperson_list);

    const columns: GridColDef[] = [
        {
            field: "user_name",
            headerName: "User Name",
            sortable: true,
            width: 180,
        },
        {
            field: "refunds_recovered",
            headerName: "Refunds Recovered",
            sortable: true,
            width: 200,
            valueFormatter: ({ value }) => value && `${value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).toString()}$`
        },
        {
            field: "fee_percentage",
            headerName: "Fee Percentage",
            sortable: true,
            width: 180,
            valueFormatter: ({ value }) => value && `${value.toString()}%`
        },
        {
            field: "fee_total",
            headerName: "Fee Total",
            sortable: true,
            width: 180,
            valueFormatter: ({ value }) => value && `${value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).toString()}$`
        }
    ];


    useEffect(() => {
        getMonthlyFees();
    }, []);

    const getMonthlyFees = (user_id=null) => {
        if (user_id || userRole === userRoles.salesperson) {
            MonthlyFeesUtils.getMonthlyFees(dispatch, user_id).then(res => {
                if (res.success) {
                    setItems(res.items);
                    setTotalCommissions(res.total_commissions);
                } else {
                    alert("error in get Monthly Fees: " + res.error)
                }
            });

        }
    };

    const downloadReport = () => {
        if (userId && userId !== '')
            MonthlyFeesUtils.downloadReportMonthlyFees(dispatch, userId);
        else
            alert('select salesperson');
    }

    const onChangeUser = (event) => {
        setUserId(event.target.value);
        getMonthlyFees(event.target.value);
    };

    return (
        <Box>
            <h2>Monthly Fees</h2>
            {userRole === userRoles.admin &&
                <Box sx={{ width: "30%" }}>
                    <Grid item xs={12} sm={6} md={12} mb={1}>
                        <InputLabel id="demo-simple-select-label">
                            Select salesperson
                        </InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="salesperson"
                                value={userId || ""}
                                onChange={onChangeUser}
                                variant="outlined"
                            >
                                {salespersons.map((user) =>
                                    <MenuItem value={user.id}>{user.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                </Box>}

            <DataGridTamplet
                columns={columns}
                rows={items}
                height={350}
            ></DataGridTamplet>
            <p className="align-right">Total commission this month:
                <span className="bold ml-10p">{`${totalCommissions.toString()}$`}</span></p>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    variant="outlined"
                    className="blue-btn"
                    sx={{
                        height: "min-content",
                        marginLeft: "15px",
                        marginTop: "20px"
                    }}
                    onClick={downloadReport}
                >
                    Download Report
                </Button>

            </Box>
        </Box>
    );
};
export default MonthlyFees;
